import { render } from "./CourseAdministratorMenuContext.vue?vue&type=template&id=1c9e38a6&scoped=true"
import script from "./CourseAdministratorMenuContext.vue?vue&type=script&lang=js"
export * from "./CourseAdministratorMenuContext.vue?vue&type=script&lang=js"

import "./CourseAdministratorMenuContext.vue?vue&type=style&index=0&id=1c9e38a6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9e38a6"]])

export default __exports__